export default __webpack_public_path__ + "static/media/mw1.26d4c1c8.webp";